import { createReducer } from 'redux-act';

import { DOMAINDATA_SET_DATA, DOMAINDATA_SET_UNDEVELOPED } from '../../actions/domainData';

const initialState = {
  data: null,
  undeveloped: false
};

export const domainDataReducer = createReducer(
  {
    [DOMAINDATA_SET_DATA]: (state, payload) => ({
      ...state,
      data: payload.data,
      undeveloped: false
    }),
    [DOMAINDATA_SET_UNDEVELOPED]: (state) => ({
      ...state,
      data: null,
      undeveloped: true
    })
  },
  initialState
);
